import Vue from "vue";

export default {
	namespaced: true,

	actions: {
		send(ctx, {title, text}) {
			Vue.notify({title, text, duration: 4000});
		}
	}
};
